<div
    class="main placement-card global-table-wrapper"
    [class.backdrop-blur]="anyModalOpen"
>
    <div class="title-btn">
        <div class="main-title">
            <h1>Cycles List</h1>
            <p>Smart AI Cycle tracking</p>
        </div>
        <div class="new-placement" *appHasRole="['Admin', 'Farm manager']">
            <a routerLink="/add-placement" class="btn btn-action-primary"
                ><i class="fas fa-plus"></i> New Cycle</a
            >
        </div>
    </div>
    <!-- Info Tiles -->
    <div class="info-tile-container">
        <app-info-tile
            [infoName]="'Active Cycles'"
            [infoValue]="activeCycles"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Total Birds'"
            [infoValue]="totalChicks"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Average Mortality'"
            [infoValue]="(AvgMortality ?? 0) + '%'"
        ></app-info-tile>
        <app-info-tile
            [infoName]="'Completed Cycles'"
            [infoValue]="completedCycles"
        ></app-info-tile>
    </div>
    <app-search-filter
        [config]="{
            fields: [
                {
                    key: 'flockNo',
                    label: 'Cycle Name',
                    type: 'text',
                    placeholder: 'Cycle Name'
                },
                {key: 'placmentDate', label: 'Date of placement', type: 'date'}
            ],
            showFarmFilter: true,
            showHouseFilter: true,
            showPartitionFilter: true
        }"
        [userId]="userDetail?.id"
        (filter)="onInlineFilter($event)"
        (clear)="onClearFilter()"
    ></app-search-filter>
    <div class="table-responsive-wrapper" style="position: relative">
        <div class="fixed-dropdown-menu" *ngIf="selectedPlan">
            <ul class="dropdown-menu-active-placement">
                <li>
                    <a
                        class="dropdown-item"
                        [routerLink]="['/placement-detail', selectedPlan.id]"
                        (click)="closeActionMenu()"
                    >
                        <i class="fas fa-eye"></i>
                        <span>View Details</span>
                    </a>
                </li>
                <li *appHasRole="['Admin']">
                    <a
                        class="dropdown-item"
                        (click)="
                            deletePlacement(selectedPlan); closeActionMenu()
                        "
                    >
                        <i class="fas fa-trash-alt"></i>
                        <span>Delete Cycle</span>
                    </a>
                </li>
                <ng-container *appHasRole="['Admin']">
                    <li *ngIf="!selectedPlan.isCycleClosed">
                        <a
                            class="dropdown-item"
                            (click)="
                                ClosePlacement(selectedPlan); closeActionMenu()
                            "
                        >
                            <i class="fas fa-times"></i>
                            <span>Close Cycle</span>
                        </a>
                    </li>
                </ng-container>
                <ng-container *appHasRole="['Admin', 'Farm manager']">
                    <li class="menu-separator" role="separator"></li>
                    <li class="menu-label">Programs</li>
                    <li>
                        <span
                            class="dropdown-item"
                            (click)="
                                openVaccinePopup(selectedPlan.id);
                                closeActionMenu()
                            "
                        >
                            <i class="fas fa-syringe"></i>
                            <span>Vaccine Program</span>
                        </span>
                    </li>
                    <li>
                        <span
                            class="dropdown-item"
                            (click)="
                                openMedicationPopup(selectedPlan.id);
                                closeActionMenu()
                            "
                        >
                            <i class="fas fa-pills"></i>
                            <span>Medication Program</span>
                        </span>
                    </li>
                    <li>
                        <span
                            class="dropdown-item"
                            (click)="
                                openMortalityPopup(selectedPlan.id);
                                closeActionMenu()
                            "
                        >
                            <i class="fas fa-heartbeat"></i>
                            <span>Mortality</span>
                        </span>
                    </li>
                    <li>
                        <span
                            class="dropdown-item"
                            (click)="
                                openChicksFeedingPopup(selectedPlan.id);
                                closeActionMenu()
                            "
                        >
                            <i class="fas fa-drumstick-bite"></i>
                            <span>Chicks Feeding</span>
                        </span>
                    </li>
                    <li>
                        <span
                            class="dropdown-item"
                            (click)="
                                openWeeklyWeightPopup(selectedPlan.id);
                                closeActionMenu()
                            "
                        >
                            <i class="fas fa-weight"></i>
                            <span>Weekly Body Weight</span>
                        </span>
                    </li>
                    <li>
                        <span
                            class="dropdown-item"
                            (click)="
                                openDisInfectionPopup(
                                    selectedPlan.id,
                                    selectedPlan.disinfectionProgramId
                                );
                                closeActionMenu()
                            "
                        >
                            <i class="fas fa-biohazard"></i>
                            <span>Disinfections</span>
                        </span>
                    </li>
                </ng-container>
            </ul>
        </div>

        <p-table
            [value]="placements"
            [paginator]="true"
            [rows]="10"
            [responsiveLayout]="'scroll'"
            [loading]="loading"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Cycle Name</th>
                    <th>Date of Placement</th>
                    <th>Farm</th>
                    <th>House</th>
                    <th>Partition</th>
                    <th>Total Birds</th>
                    <th>Avg. Weight (grm)</th>
                    <th>Status</th>
                    <th class="text-right actions-col">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-plan let-rowIndex="rowIndex">
                <tr [ngClass]="{'closed-row': plan.isCycleClosed}">
                    <td>{{ plan.flockNo }}</td>
                    <td>{{ plan.placementDateTime | date: 'yyyy-MM-dd' }}</td>
                    <td>
                        <span class="placement-tags">{{ plan.farmName }}</span>
                    </td>
                    <td>
                        <div class="house-column">
                            <span
                                *ngFor="
                                    let house of plan.farmhouseName.split(',')
                                "
                                class="placement-tags house-tag"
                            >
                                {{ house }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="partition-column">
                            <span
                                *ngFor="
                                    let partition of plan.partitionName.split(
                                        ','
                                    )
                                "
                                class="placement-tags partition-tag"
                            >
                                {{ partition }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <span class="placement-tags">{{
                            plan.numberOfBirds | number
                        }}</span>
                    </td>
                    <td>{{ plan.weight }}g</td>
                    <!-- <td>{{ plan.density }}</td> -->
                    <td>
                        <span
                            class="status-badge"
                            [ngClass]="plan.isCycleClosed ? 'closed' : 'active'"
                            >{{
                                plan.isCycleClosed ? 'Closed' : 'Active'
                            }}</span
                        >
                    </td>
                    <td class="text-right actions-col">
                        <span
                            class="btn-master-edit"
                            (click)="openActionMenu(plan, $event)"
                        >
                            <i class="fas fa-ellipsis-h"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginator" let-paginator>
                <div class="p-d-flex p-jc-between p-ai-center">
                    <p-paginator
                        [rows]="10"
                        [totalRecords]="placements?.length"
                    ></p-paginator>
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
<!-- delete dialog-->
<p-dialog
    [(visible)]="displayDeleteDialog"
    modal="true"
    [closable]="false"
    [style]="{width: '400px'}"
    [responsive]="true"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <p class="text-center">Are you sure you want to delete?</p>
    <div class="text-center">
        <button
            (click)="deleteItem(itemToDelete.id)"
            class="btn btn-primary mr-1"
        >
            Yes
        </button>
        <button (click)="displayDeleteDialog = false" class="btn btn-secondary">
            No
        </button>
    </div>
</p-dialog>
<p-dialog
    [(visible)]="displayClosePlacementDialog"
    modal="true"
    [closable]="false"
    [style]="{width: '400px'}"
    [responsive]="true"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <p class="text-center">Are you sure you want to Close Cycle?</p>
    <div class="text-center">
        <button
            (click)="closecycleItem(itemToDelete.id)"
            class="btn btn-primary mr-1"
        >
            Yes
        </button>
        <button
            (click)="displayClosePlacementDialog = false"
            class="btn btn-secondary"
        >
            No
        </button>
    </div>
</p-dialog>
<!--complete delete dialog-->
<!--Active Mortality-->
<p-dialog
    [(visible)]="displayDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <!-- Mortality Component loaded in the Dialog -->
        <app-active-mortality
            [placementId]="selectedPlanId"
            (close)="onCloseDisinfectionDialog()"
        ></app-active-mortality>
    </ng-template>
</p-dialog>
<!--Active Feeding-->
<p-dialog
    [(visible)]="displayfeedingDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <!-- Mortality Component loaded in the Dialog -->
        <app-chicks-feeding-program
            [placementId]="selectedPlanId"
            (close)="onCloseDisinfectionDialog()"
        ></app-chicks-feeding-program>
    </ng-template>
</p-dialog>
<!--Active Weekly weight-->
<p-dialog
    [(visible)]="displayWeeklyWeightDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <!-- Mortality Component loaded in the Dialog -->
        <app-average-body-weight
            [placementId]="selectedPlanId"
            (close)="onCloseDisinfectionDialog()"
        ></app-average-body-weight>
    </ng-template>
</p-dialog>

<!--Active Vaccine -->
<p-dialog
    [(visible)]="displayVaccineDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <!-- Mortality Component loaded in the Dialog -->
        <app-active-vaccines-program
            [placementId]="selectedPlanId"
            (close)="onCloseDisinfectionDialog()"
        ></app-active-vaccines-program>
    </ng-template>
</p-dialog>
<!--Active Medication -->
<p-dialog
    [(visible)]="displayMedicationDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <!-- Mortality Component loaded in the Dialog -->
        <app-active-medication-program
            [placementId]="selectedPlanId"
            (close)="onCloseDisinfectionDialog()"
        ></app-active-medication-program>
    </ng-template>
</p-dialog>
<p-dialog
    [(visible)]="displaydisinfectionDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '1100px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <!-- Mortality Component loaded in the Dialog -->
        <app-active-disinfection-program
            [placementId]="selectedPlanId"
            [disInfectionType]="diInfectionTypeId"
            (close)="onCloseDisinfectionDialog()"
        ></app-active-disinfection-program>
    </ng-template>
</p-dialog>
